import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function deleteOrganizationAffiliation(id) {
  if (!id) {
    return {
      success: false,
      message: "삭제할 소속을 선택해 주세요.",
      data: null,
      code: "INVALID_ORGANIZATION_ID",
    };
  }

  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/affiliations/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
    const data = await response.json().catch(() => ({}));

    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
      code: data?.code ?? "",
    };
  } catch (error) {
    console.error("[deleteOrganizationAffiliation] failed:", error);
    return {
      success: false,
      message: "하위 소속 삭제 중 오류가 발생했습니다.",
      data: null,
      code: "NETWORK_ERROR",
    };
  }
}
